export default __webpack_public_path__ + "static/media/flat_menu_exaprint.14fbd90e.jpg";